import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import FavoriteButtonComponent from './component'

export const Favorite = combine(
  withTableController({ id: 'favorite-athlete-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withCallback(
    'onFavoriteButton',
    ({ followerService, table }, { value }) =>
      () => {
        followerService
          .removeFollowers({ tournamentIds: [value.tournamentDTO.id] })
          .then(() => table.refresh())
      },
    ['value']
  )
)(FavoriteButtonComponent)
